<template>
  <div class="page-info">
    <n-loader :loading="$var('load')" />
    <c-left-side-bar :step="1" />
    <div class="mid-container">
      <div class="mid-side">
        <div class="routers">
          <n-button
            class="btn-start"
            @click="kln"
            :disabled="$route.name === 'kln-info'"
          >
            КЛН
          </n-button>
          <n-button
            class="btn-start"
            @click="timer"
            :disabled="$route.name === 'kln-timer-info'"
          >
            Оценки
          </n-button></div>


        <div class="tabs">
          <n-tabs :data="tabs" state name="resultStatus">
            <template #tab="{item}">
              {{ item.title }}
            </template>
          </n-tabs>
        </div>
        <div class="filters">
          <div class="filter">
            <n-input title="От" type="date" v-bind="$form.input('from', 'select')"></n-input>
            <n-input title="До" type="date" v-bind="$form.input('to', 'select')"></n-input>
          </div>
          <n-button @click="$form.reset()">Сброс</n-button>
        </div>
        <n-form @submit="load">
          <n-items>
            <div class="input-place">
              <n-button type="submit"><img :src="searchIcon" alt=""></n-button>
              <n-input v-model="search" placeholder="Поиск табельному номеру или ФИО" />
            </div>
          </n-items>
        </n-form>
        <n-tabs-content name="resultStatus">
          <template #finished>
            <n-link v-for="item in filteredResults" :key="item.id" :to="{name: 'kln-result', query: {resultId: item.id}}">
              <div class="result-box">
                <div class="user-part">
                  <img :src="altAvatar" alt="">
                  <div class="user-part-info">
                    <h3>{{ item.user?.fullName }}</h3>
                    <p>Табельный номер: {{ item.user?.personnelNumber }}</p>
                  </div>
                </div>
                <div class="result-part">
                  <p>Результат: {{ Math.round(item.points) }} %</p>
                </div>
              </div>
            </n-link>
          </template>
          <template #expired>
            <n-link v-for="item in filteredResults" :key="item.id" :to="{name: 'kln-result', query: {resultId: item.id}}">
              <div class="result-box">
                <div class="user-part">
                  <img :src="altAvatar" alt="">
                  <div class="user-part-info">
                    <h3>{{ item.user?.fullName }}</h3>
                    <p>Табельный номер: {{ item.user?.personnelNumber }}</p>
                  </div>
                </div>
                <div class="result-part">
                  <p>Результат: {{ Math.round(item.points) }} %</p>
                </div>
              </div>
            </n-link>
          </template>
          <template #unaccepted>
            <n-link v-for="item in filteredResults" :key="item.id" :to="{name: 'kln-result', query: {resultId: item.id}}">
              <div class="result-box">
                <div class="user-part">
                  <img :src="altAvatar" alt="">
                  <div class="user-part-info">
                    <h3>{{ item.user?.fullName }}</h3>
                    <p>Табельный номер: {{ item.user?.personnelNumber }}</p>
                  </div>
                </div>
                <div class="result-part">
                  <p>Результат: {{ Math.round(item.points) }} %</p>
                </div>
              </div>
            </n-link>
          </template>
          <template #declined>
            <n-link v-for="item in filteredResults" :key="item.id" :to="{name: 'kln-result', query: {resultId: item.id}}">
              <div class="result-box">
                <div class="user-part">
                  <img :src="altAvatar" alt="">
                  <div class="user-part-info">
                    <h3>{{ item.user?.fullName }}</h3>
                    <p>Табельный номер: {{ item.user?.personnelNumber }}</p>
                  </div>
                </div>
                <div class="result-part">
                  <p>Результат: {{ Math.round(item.points) }} %</p>
                </div>
              </div>
            </n-link>
          </template>
          <template #interrupted>
            <n-link v-for="item in filteredResults" :key="item.id" :to="{name: 'kln-quizzes', query: {categoryId: item.categoryId, resultId: item.id}}">
              <div class="result-box">
                <div class="user-part">
                  <img :src="altAvatar" alt="">
                  <div class="user-part-info">
                    <h3>{{ item.user?.fullName }}</h3>
                    <p>Табельный номер: {{ item.user?.personnelNumber }}</p>
                  </div>
                </div>
                <img :src="selectRow" alt="" class="select-icon">
              </div>
            </n-link>
          </template>
          <template #nonUser>
            <n-link
              v-for="item in filteredResults" :key="item.id"
              :to="{name: 'kln-result', query: {resultId: item.id}}">
              <div class="result-box">
                <div class="user-part">
                  <img :src="altAvatar" alt="">
                  <div class="user-part-info">
                    <h3>Обучающийся</h3>
                  </div>
                </div>
                <div class="result-part">
                  <p>Результат: {{ Math.round(item.points) }} %</p>
                </div>
              </div>
            </n-link>
          </template>
        </n-tabs-content>
      </div>
    </div>
    <div class="new-right-side right-container">
      <div class="right-side">
        <div>
          <div class="branch-selector" @click="showBranches = true">
            <div class="title">{{ branch?.title }}</div>
            <div class="icon-place">
              <img :src="selectRow" alt="">
            </div>
          </div>
          <h2>Памятка</h2>
          <div class="text-container">
            <p>
              Проведение КЛН — важная часть
              в нашей компании. Она проводится для улучшения качества работы и возможности роста
            </p>
            <p>
              Если сотрудника не устроили результаты ответов по окончании аттестации,
              он может отказаться от отправки данных в систему. Позже сотрудник может пересдать аттестацию
            </p>
          </div>
        </div>
        <n-button class="btn-start" @click="start" >Начать клн</n-button>
      </div>
    </div>
  </div>
</template>

<script>
import searchIcon from 'assets/searchIcon/search-btn-icon.png'
import altAvatar from 'assets/altAvatar/alt-avatar.png'
import selectRow from 'assets/sectionRow/section-row.png'

export default {
  name: 'PageInfo',
  data() {
    return {
      tabs: [
        { name: 'unaccepted', title: 'Не подтвержденные', },
        { name: 'finished', title: 'Завершенные', },
        { name: 'expired', title: 'Автосогласованные', },
        { name: 'interrupted', title: 'Прерванные', },
        { name: 'declined', title: 'Не согласованные', },
        { name: 'nonUser', title: 'Обучение (без сотрудника)', },
      ],
      search: '',
      user: $app.auth.user(),
      results: [],
      branch: localStorage.getItem('branch')? JSON.parse(localStorage.getItem('branch')) : {},
      altAvatar,
      searchIcon,
      selectRow,
    }
  },
  computed: {
    formFrom() {
      return this.$form.get('from')
    },
    formTo() {
      return this.$form.get('to')
    },
    tab() {
      return this.$route.query.resultStatus
    },
    filteredResults() {
      const regex = new RegExp(this.search, 'i')
      if (this.search.length > 0) {
        return $n.filter(this.results, (item) => {
          const result = item.user?.personnelNumber?.match(regex)
          return result?.length > 0 || item.user?.fullName?.match(regex)
        })
      } else {
        return this.results
      }
    },
  },
  watch: {
    tab() {
      this.search = ''
      this.load(false)
    },
    'formFrom'() {
      this.load()
    },
    'formTo'() {
      this.load()
    },
  },
  created() {
    this.branch = this.user.branch
    this.load(true)
    this.$form.init({
      personnelNumber: '',
      from: $app.date.format(new Date().setDate(1), 'filterDate'),
      to: $app.date.format(new Date(new Date().setMonth(new Date().getMonth() + 1)).setDate(0), 'filterDate'),
    })
  },
  methods: {
    kln() {
      this.$router.push({ name: 'kln-info', })
    },
    timer() {
      this.$router.push({ name: 'kln-timer-info', })
    },
    start() {
      this.$router.push({ name: 'kln-user-select', query: { type: 'kln', }, })
    },
    load(isFirstTime) {
      this.$var('load', true)
      let api = $api.results.get().with('user')
        .filter({ createdAt: 'between:' + this.$form.get('from') + ',' + this.$form.get('to'), })
        .filter({ status: isFirstTime ? 'unaccepted' : this.tab, })
        .filter({ byUserId: 'notNull', })
        .filter({ branchId: this.branch?.id, })
        .filter({ authorId: $app.auth.user().id, })
      if (this.tab === 'nonUser') {
        api = $api.results.get().with('user')
          .filter({ branchId: this.branch?.id, })
          .filter({ byUserId: 'null', })
      }
      if (this.$form.get('personnelNumber') !== '') {
        api = api.filter({ personnelNumber: this.$form.get('personnelNumber'), })
      }
      // if (this.$form.get('from') && this.$form.get('to')) {
      //   api.filter({ createdAt: 'between:' + this.$form.get('from') + ',' + this.$form.get('to'), })
      // }
      api.then((response) => {
        this.results = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.page-info {
  display: flex;
  align-items: stretch;

  ::v-deep {
    .n-tabs {
      overflow: auto;
      flex-wrap: nowrap;
      margin: 10px 0;
    }
    .n-tab {
      flex-shrink: 0;
    }
  }

  .branch-selector {
    background-color: #e8e8e8;
    padding: 8px;
    height: 40px;
    border-radius: 8px;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    .title {
      font-size: 16px;
    }
    .icon-place {
      margin-right: 10px;
      transform: rotate(90deg);
      width: 8px;
      height: 14px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

  }

  .branches-shadow {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.2);
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    .window {
      position: relative;
      background-color: #ffffff;
      min-width: 300px;
      min-height: 400px;
      max-height: 800px;
      border-radius: 8px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      padding: 10px;
      .top {
        overflow: auto;
        .title {
          text-align: center;
          font-size: 16px;
          font-weight: bold;
        }
        .branches-list {
          margin-top: 15px;
          .icon {
            margin-right: 10px;
          }
          .branch-item {
            cursor: pointer;
            padding: 5px;
            background-color: #e8e8e8;
            height: 40px;
            margin-bottom: 10px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .title {
              font-weight: normal;
            }
          }
        }
      }
    }
  }

  .side-bar {
    display: flex;
    flex-direction: column;
    background-color: #F4F4F4;
    width: 165px;
    align-items: center;
    justify-content: center;

    .page-icons {
      padding: 15px 0 15px 0;

      .page-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 54px;
        height: 54px;
        margin: 90px 55px 100px 55px;
        border-radius: 50%;
        background-color: rgba(255, 188, 13, 0);
        transition: background-color .3s ease-in-out;

        &.active {
          background-color: rgba(255, 188, 13, 0.2);
          margin: 90px 55px 100px 55px;
        }

        &:hover {
          background-color: rgba(255, 188, 13, 0.2);
        }
      }
    }
  }

  .mid-container {
    padding: 40px 20px 0 20px;
    width: 100%;
    height: 100vh;

    position: relative;

    .mid-side {
      .routers{
        ::v-deep{
          .n-button:disabled {
            background-color: #f90;
            opacity: 1;
          }
          .n-button{
            background-color: #b4b4b4;
            margin-left: 2%;
            width: 100px;
            height: 35px;
            color: #fff;
            opacity: 0.8;
            border: none;
          }
        }

      }
      h1 {
        text-align: left;
        vertical-align: center;
        font-size: 17px;
        font-weight: bold;
        color: #000000;
      }

      .tabs {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .filters {
        padding: 20px;
        display: flex;
        align-items: end;
        ::v-deep {
          .n-button {
            min-height: 47px;
          }
        }
        .filter {
          margin-right: 55px;
          display: flex;
          align-items: center;
          max-width: 300px;
          .n-input {
            margin-right: 15px;
          }
        }
      }

      &::v-deep .n-tabs {
        position: relative;
        color: #969FA8;
        font-weight: bold;
        font-size: 17px;
        text-align: center;
        padding: 0;

        & .active {
          color: #292929;
          border-bottom: 2px solid #292929;
        }
      }

      .input-place {
        margin-top: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #F4F4F4;
        border-radius: 10px;
        position: relative;

        &::v-deep .n-input {
          width: 510px;

          .n-content {
            border: none;
            background-color: #F4F4F4;
            border-radius: 10px;
          }
        }

        &::v-deep .n-button {
          border: none;
          background-color: inherit;

          img {
            position: absolute;
            top: 14px;
            left: 15px;
            bottom: -10px;
            width: 16px;
            height: 16px;
          }
        }

        &::v-deep .n-button:active {
          box-shadow: none;
          border-color: inherit;
          background-color: transparent !important;
          outline: none !important;
        }
      }

      &::v-deep .n-tabs-content{
        overflow: auto;
        max-height: 73vh;
        .result-box {
          margin: 22px 0 10px 0;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: space-between;

          &:before {
            content: '';
            position: absolute;
            width: 80%;
            height: 1px;
            background-color: #E9E9EC;
            right: 53px;
            bottom: -9px;
          }

          .user-part {
            display: flex;
            justify-content: space-between;

            .select-icon {
              width: 7px;
              height: 14px;
              margin-right: 27px;
            }

            img {
              width: 44px;
              height: 44px;
            }

            .user-part-info {
              padding-left: 12px;
              display: flex;
              flex-direction: column;
              justify-content: center;

              h3 {
                padding: 3px 0 0 0;
                font-size: 17px;
                color: #292929;
                margin: 0;
              }

              p {
                padding: 3px 0 0 0;
                margin: 0;
                font-size: 14px;
                color: #6D6F7B;
              }
            }
          }
      }

        .result-part {
          p {
            padding: 0;
            margin: 0;
            font-size: 17px;
            color: #6D6F7B;
          }
        }
      }
    }
  }

  .right-container {
    .right-side {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      h2 {
        margin-top: 0;
        font-weight: bold;
        font-size: 28px;
      }

      .text-container {
        p {
          position: relative;
          max-width: 400px;
          font-size: 14px;
          color: #292929;
          padding-left: 12px;

          &.secondary {
            color: #6D6F7B;
            padding: 0;

            &::before {
              display: none;
            }
          }

          &::before {
            content: '';
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: #264F36;
            position: absolute;
            left: 0;
            top: 8px;
          }
        }
      }

      .btn-start {
        font-size: 17px;
        background-color: #264F36;
        color: #ffffff;
        max-width: 390px;
        width: 100%;
        font-weight: bold;
      }

      &::v-deep .n-button:hover {
        background-color: #3C7853;
      }

      &::v-deep .n-button:active {
        background-color: #0F4122;
      }
    }
  }
}
</style>
